import { useDisableIntercomWidget } from '@/services/intercomReboot';
import { type PropsWithChildren } from 'react';

export function IntercomDisabledRoute({ children }: PropsWithChildren) {
  // Public or otherwise unauthenticated routes should not inherit a stale authenticated Intercom session.
  useDisableIntercomWidget();

  return <>{children}</>;
}
